var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[_c('div',{staticClass:"stk-detail-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),(_vm.value)?_c('div',{staticClass:"stk-detail-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('div',{staticClass:"stk-detail-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }